import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { BillsTableRow } from '../../types/billsTableRow'
import { isBillsTableFieldSuggestion } from '../../utils/isBillsTableFieldSuggestion'
import { BillsTableNoDataField } from '../BillsTableNoDataField'
import { BillsTableSuggestedField } from '../BillsTableSuggestedField'

interface BillsTableReferenceCellProps {
  row: BillsTableRow
}

export const BillsTableReferenceCell = ({ row }: BillsTableReferenceCellProps): ReactElement => {
  if (isBillsTableFieldSuggestion(row.reference) && row.reference.suggestion !== '') {
    return <BillsTableSuggestedField value={row.reference.suggestion} />
  }

  if (row.reference.actual === null || row.reference.actual === '') {
    return <BillsTableNoDataField />
  }

  return <Typography.Text>{row.reference.actual}</Typography.Text>
}
